<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="update()">
        <mat-icon>save</mat-icon>
        <span class="hide-text">{{ updateButtonName | translate }}</span>
    </button>

    <button mat-raised-button color="primary" (click)="updateAndReturn()">
        <mat-icon>playlist_add</mat-icon>
        <span class="hide-text">{{ updateThenContinueButtonName | translate }}</span>
    </button>
    <ng-content></ng-content>
</div>
